// extracted by mini-css-extract-plugin
export default {"container":"u0RMwA7RXr0Srilro9x8__container___"};